<template>
    <div class="personal-selector">
      <!-- Título con botón de colapsar -->
      <div class="header">
        <h5 @click="toggleCollapsed" class="toggle-title">
          Selección de Personal
          <font-awesome-icon
            :icon="['fas', collapsed ? 'chevron-down' : 'chevron-up']"
            class="ms-2"
          />
        </h5>
        <div v-if="collapsed" class="collapsed-summary">
          <span
            v-for="persona in visibleSelected"
            :key="'summary-' + persona.id"
            class="pill selected"
          >
            {{ persona.nombre }} {{ persona.apellido }}
          </span>
          <span v-if="hiddenSelectedCount > 0" class="more-pill">
            +{{ hiddenSelectedCount }} más
          </span>
        </div>
      </div>
  
      <!-- Contenido colapsable -->
      <div v-if="!collapsed" class="grouped-list">
        <!-- Personal no seleccionado -->
        <div class="unselected-group">
          <h6 class="group-title">No seleccionados</h6>
          <div class="pill-container">
            <div
              class="pill"
              v-for="persona in filteredUnselectedPersonal"
              :key="'unselected-' + persona.id"
              @click="toggleSelection(persona)"
            >
              {{ persona.nombre }} {{ persona.apellido }}
              <small class="ms-2 text-muted">(Legajo: {{ persona.legajo }})</small>
              <font-awesome-icon
                :icon="['fas', 'plus']"
                class="ms-2"
                title="Agregar"
              />
            </div>
          </div>
        </div>
  
        <!-- Personal seleccionado -->
        <div class="selected-group">
          <h6 class="group-title">Seleccionados</h6>
          <div class="pill-container">
            <div
              class="pill selected"
              v-for="persona in selectedPersonal"
              :key="'selected-' + persona.id"
              @click="toggleSelection(persona)"
            >
              {{ persona.nombre }} {{ persona.apellido }}
              <small class="ms-2 text-muted">(Legajo: {{ persona.legajo }})</small>
              <font-awesome-icon
                :icon="['fas', 'times']"
                class="ms-2"
                title="Quitar"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "@/axios";
  
  export default {
    data() {
      return {
        personal: [], // Lista completa de personal
        searchQuery: "", // Texto de búsqueda
        selectedPersonal: [], // Personal seleccionado
        collapsed: false, // Estado de colapsado/expandido
        maxVisiblePills: 3, // Máximo de seleccionados a mostrar en el resumen
        clubActual: null,
      };
    },
    computed: {
      filteredUnselectedPersonal() {
        return this.personal.filter(
          (persona) =>
            !this.selectedPersonal.some((selected) => selected.id === persona.id)
        );
      },
      visibleSelected() {
        return this.selectedPersonal.slice(0, this.maxVisiblePills);
      },
      hiddenSelectedCount() {
        return this.selectedPersonal.length - this.visibleSelected.length;
      },
    },
    methods: {
      async fetchPersonal() {
        try {
          const response = await axios.get(
            "/api/personal",
            { params: { club_id: this.clubActual.id } }
          );
          this.personal = response.data;
        } catch (error) {
          console.error("Error al obtener el personal:", error);
        }
      },
      toggleSelection(persona) {
        if (this.selectedPersonal.some((selected) => selected.id === persona.id)) {
          this.selectedPersonal = this.selectedPersonal.filter(
            (selected) => selected.id !== persona.id
          );
        } else {
          this.selectedPersonal.push(persona);
        }
        this.emitSelection();
      },
      emitSelection() {
        this.$emit("selected-personal", this.selectedPersonal);
      },
      toggleCollapsed() {
        this.collapsed = !this.collapsed;
      },
    },
    mounted() {
      this.clubActual = this.$store.getters.getClubActual;
      this.fetchPersonal();
    },
  };
  </script>
  
  <style scoped>
  .personal-selector {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    background-color: #f8f9fa;
    padding: 10px;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .toggle-title {
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    color: var(--app-primary);
    display: inline-flex;
    align-items: center;
  }
  
  .collapsed-summary {
    display: flex;
    align-items: center;
    gap: 5px;
    overflow-x: auto;
  }
  
  .grouped-list {
    display: flex;
    gap: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  
  .unselected-group,
  .selected-group {
    flex: 1;
  }
  
  .group-title {
    font-size: 0.9rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 5px;
    color: #6c757d;
  }
  
  .pill-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  
  .pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 50px;
    cursor: pointer;
    font-size: 0.8rem;
    transition: all 0.3s ease;
    border: 1px solid #dee2e6;
    background-color: #e9ecef;
    color: #495057;
  }
  
  .pill.selected {
    background-color: var(--app-primary);
    color: #fff;
    border-color: var(--app-primary);
  }
  
  .pill:hover {
    background-color: #ced4da;
  }
  
  .more-pill {
    font-size: 0.8rem;
    font-weight: bold;
    color: var(--app-primary);
  }

  @media (max-width: 768px) {
    .personal-selector {
      padding: 8px;
    }

    .toggle-title {
      font-size: 0.9rem;
    }

    .grouped-list {
      flex-direction: column;
      max-height: none;
    }

    .pill-container {
      justify-content: center;
    }

    .pill {
      font-size: 0.7rem;
      padding: 3px 6px;
    }

    .group-title {
      font-size: 0.8rem;
    }
  }
  </style>
  